import {useEffect, useState} from "react";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";



const COMPANY_LOGO_PATH = 'https://storage.googleapis.com/finiat-web-static-resources/company-brands/id-lookup';


export const formatCompanyLogoUrl = (cid)=>{
    if (!cid){
      return `${COMPANY_LOGO_PATH}/finiat.png`
    }
    return `${COMPANY_LOGO_PATH}/${cid}.png`
}



export const updateCompanyDetails = createAsyncThunk(
  'company/updateDetails',
  async ({ userId, companyId, data }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/company/details/update`, {
        method: 'POST',
        body: data,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update company details');
      }

      const updatedCompany = await response.json();
      return updatedCompany;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCompanyLogo = async (companyId, logoFile) => {
  const formData = new FormData();
  formData.append('logo', logoFile);
  formData.append('company_id', companyId);

  try {
    const response = await fetch(`${HOSTNAME}/company/logo/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update company logo');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating company logo:', error);
    throw error;
  }
};
